<script lang="ts">
    import {Menu, MenuButton, MenuItems} from '@rgossiaux/svelte-headlessui';
    import {createFloatingActions} from 'svelte-floating-ui';
    import {offset} from 'svelte-floating-ui/dom';
    import {flip} from '@floating-ui/core';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let isDisabled = false;
    export let additionalButtonClasses = '';
    export let additionalContainerClasses = '';
    export let additionalMenuClasses = '';
    export let arrowHidden = false;
    const [floatingRef, floatingContent] = createFloatingActions({
        placement: 'bottom-end',
        strategy: 'fixed',
        middleware: [
            offset(10),
            flip()
        ]
    });
</script>

<Menu as="div" class="kp-dropdown-wrapper {additionalContainerClasses}">
    <MenuButton use={[floatingRef]}
                disabled="{isDisabled}"
                class="dropdown-wrapper-button dropdown-toggle {additionalButtonClasses}"
                let:open>

        <slot name="button"/>

        {#if !arrowHidden}
            <span class="icon-container" class:opened={open}>
                <UIcon icon="angle-small-down" additionalClasses="dropdown-angle-arrow"/>
            </span>
        {/if}
    </MenuButton>

    <MenuItems as="ul"
               use={[floatingContent]}
               class="dropdown-menu {additionalMenuClasses}">

        <slot name="menu"/>
    </MenuItems>
</Menu>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    :global {
        .kp-dropdown-wrapper {
            display: flex;
            flex-direction: column;
            white-space: normal;

            .dropdown-wrapper-button {
                display: inline-flex;
                align-items: center;
                cursor: pointer;
                border: none;
                background: none;
                padding: 0;
                gap: @spacing-s;

                .icon-container {
                    font-size: @font-size-small;
                    transition: rotate 0.2s ease-in-out;

                    &.opened {
                        rotate: -180deg;
                    }
                }
            }

            .dropdown-menu {
                max-height: 400px;
                max-width: 260px;
                overflow-y: auto;
                display: flex;
                flex-direction: column;
                padding: @spacing-s @spacing-sm;
                gap: @spacing-s;

                &.dropdown-menu-shown {
                    z-index: 1100;
                    display: block;
                }
            }
        }
    }
</style>